"use client";

import Image from "next/image";
import Link from "@/components/ui/Link";
import { MessageIcon } from "../ui/message-icon";
import { Frame } from "@/components/ui/frame";
import { BOOKMARK_CATEGORIES } from "@/lib/api/public-client";
import { FALLBACK_IMAGE } from '@/lib/constants';
import { getImageUrl, getTimeAgo, getFocusPointStyle, ImageMetadata } from '@/lib/componentutills';

type FieldConfig = {
  hidden?: boolean;
  value?: string;
  customClass?: string;
};

type Props = {
  title?: FieldConfig;
  timeAgo?: FieldConfig;
  imageSrc?: FieldConfig;
  slug?: string;
  count?: string;
  imageMetadata?: ImageMetadata;
};

export const VerticalSmallImagesNews = ({
  title = { hidden: false, value: "பெண் பார்க்க போன வெற்றிக்கு ஷக்தி வைத்த ட்விஸ்ட்.!", customClass: "" },
  timeAgo = { hidden: false, value: "2 hours ago", customClass: "" },
  imageSrc = { hidden: false, value: FALLBACK_IMAGE, customClass: "" },
  slug,
  count = "5",
  imageMetadata,
}: Props) => {
  const titleValue = title?.value || "";
  const timeAgoValue = getTimeAgo(timeAgo?.value);
  const imageSrcValue = getImageUrl(imageSrc?.value) || FALLBACK_IMAGE;

  const content = (
    <div className="flex flex-col overflow-hidden p-4 gap-4">
      {/* IMAGE - aspect-ratio ensures uniform sizing across all equal-width grid items */}
      {!imageSrc?.hidden && (
        <div className={`relative w-full aspect-[16/9] overflow-hidden ${imageSrc?.customClass || ""}`}>
          <img
            src={imageSrcValue}
            alt={titleValue}
            className="absolute inset-0 w-full h-full object-cover"
            style={getFocusPointStyle(imageMetadata)}
            loading="lazy"
          />
        </div>
      )}

      {/* CONTENT */}
      <div className="flex flex-col gap-5">
        {/* Title */}
        {!title?.hidden && (
 <h3 className={`text-16-tamil-700 leading-[1.4] text-020202 ${title?.customClass || ""}`}>
            {titleValue}
          </h3>
        )}

        {/* Footer */}
        <div className="flex justify-between items-center text-020202 gap-3">
          {!timeAgo?.hidden && (
            <span className={`text-12-tamil-500 text-020202 ${timeAgo?.customClass || ""}`}>{timeAgoValue}</span>
          )}
          <MessageIcon
            id="message-icon-4"
            slug={slug}
            category={BOOKMARK_CATEGORIES.PHOTOS}
            title={titleValue}
            thumbnailUrl={imageSrcValue}
            articleUrl={slug ? `/${slug}` : undefined}
          />
        </div>
      </div>
    </div>
  );

  if (slug) {
    return (
      <Link href={`/${slug}`} className="block hover:opacity-90 transition-opacity cursor-pointer">
        {content}
      </Link>
    );
  }

  return content;
};
